export default __webpack_public_path__ + "static/media/A0007.53dc5f22.png";